
import { Configuration } from '@/@core/configuration';
import Vue from 'vue';

export default Vue.extend({
    data(){
        return {
            releaseTitle: null as unknown as string
        }
    },
    async mounted(){
        this.releaseTitle = await Configuration.get("releaseInfo")
    }
})
